import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "legal-page"
};
const _hoisted_2 = {
  class: "legal-main"
};
const _hoisted_3 = {
  class: "legal-container"
};
const _hoisted_4 = {
  class: "legal-head"
};
const _hoisted_5 = {
  class: "legal-eyebrow"
};
const _hoisted_6 = {
  class: "legal-title"
};
const _hoisted_7 = {
  class: "legal-summary"
};
const _hoisted_8 = {
  class: "legal-block__title"
};
const _hoisted_9 = {
  class: "legal-index",
  "aria-hidden": "true"
};
const _hoisted_10 = {
  key: 0,
  class: "legal-list"
};
const _hoisted_11 = {
  class: "legal-foot"
};
import { computed } from 'vue';
import NavBar from '@/components/layout/NavBar.vue';
import Footer from '@/components/layout/Footer.vue';
const updatedAt = '2026 年 10 月 14 日';
export default {
  __name: 'Legal',
  props: {
    type: {
      type: String,
      default: 'privacy'
    }
  },
  setup(__props) {
    const props = __props;
    const documents = {
      privacy: {
        eyebrow: 'PRIVACY POLICY',
        title: '隐私政策',
        summary: '这份说明告诉你：为了提供睡眠监测、助眠音频与咨询服务，我们会收集哪些信息、怎么使用、保存在哪里，以及你可以要求我们做什么。',
        blocks: [{
          title: '我们收集哪些信息',
          items: ['你在「申请体验」弹窗、页脚留言中填写的称呼、手机号、邮箱、性别、年龄与留言内容；', '你在「联系我们」页商务合作表单中填写的公司名称、联系人、联系电话与合作需求；', '使用设备与 App 过程中产生的脑电信号、睡眠状态记录与必要的运行日志。'],
          paragraphs: []
        }, {
          title: '我们如何使用这些信息',
          paragraphs: ['用于回复你的咨询、体验申请与售后请求；用于生成你的睡眠状态报告并按当晚状态推送助眠音频；用于产品的缺陷修复与模型迭代；以及法律法规要求的其他用途。', '我们不会把脑电与睡眠数据用于与睡眠健康服务无关的用途，也不会将其用于对外发布的统计结果中可识别到个人的形式。']
        }, {
          title: '信息的保存与保护',
          paragraphs: ['提交的表单信息与设备睡眠数据保存在中国境内的服务器上，传输过程使用 HTTPS 加密。我们按用途分开存放数据，只允许履行职责所必需的员工与技术人员访问，并保留访问记录。', '我们会在实现上述目的所必需的期限内保存你的信息，超出期限后将删除或匿名化处理。']
        }, {
          title: '信息的共享',
          paragraphs: ['我们不会出售你的个人信息。除法律法规要求、司法机关或行政主管部门依法调取，或已取得你的单独同意外，我们不会向第三方提供你的个人信息。']
        }, {
          title: '你的权利',
          items: ['查询、更正或删除你此前提交的信息；', '撤回你对信息收集与使用的同意；', '要求解绑设备并删除对应的账号与睡眠数据。'],
          paragraphs: ['以上需求可通过下方电话或邮箱提出，我们会在收到并核实身份后 15 个工作日内处理。']
        }, {
          title: '未成年人',
          paragraphs: ['我们的产品与服务面向成年人。如你未满 18 周岁，请在监护人陪同下使用并提交信息；我们不会主动收集未满 14 周岁儿童的个人信息。']
        }, {
          title: '本政策的更新',
          paragraphs: ['本政策更新后，最新版本与更新日期会在本页面公布；如涉及信息收集范围或使用方式的重大变更，我们会通过页面提示等方式另行告知。']
        }, {
          title: '联系我们',
          paragraphs: ['电话：0510-85382052（工作日 9:00–21:00，周末 10:00–18:00）；邮箱：2759450915@qq.com；地址：江苏省无锡市新吴区清源路 20 号立业楼 C 栋二楼 213。']
        }]
      },
      terms: {
        eyebrow: 'TERMS OF SERVICE',
        title: '服务条款',
        summary: '这份条款说明使用本网站、App 与相关服务时的基本约定。访问或使用本站即表示你已阅读并接受以下内容。',
        blocks: [{
          title: '网站内容性质',
          paragraphs: ['本网站用于介绍公司与产品、提供 App 下载与联系方式，站内内容不构成医疗诊断、治疗建议或用药指导。如有睡眠障碍或相关疾病，请及时就医并遵循专业医疗机构的意见。']
        }, {
          title: '产品与服务说明',
          paragraphs: ['页面中的参数、功能与配件以实际交付的产品、说明书以及双方签署的合同为准；App 功能会随版本更新调整，具体以应用内说明为准。']
        }, {
          title: '知识产权',
          paragraphs: ['本站的文字、图形、标识、界面设计与专利信息归无锡特文思达健康科技有限公司或相关权利人所有。未经书面许可，不得复制、转载、镜像或用于商业用途。']
        }, {
          title: '用户提交的信息',
          paragraphs: ['你在表单中提交的信息应真实、准确、合法，不得包含违法、侵权或与本次沟通无关的内容；因信息不实造成的后果由提交人自行承担。']
        }, {
          title: '责任说明',
          paragraphs: ['我们会尽力保证网站与 App 的稳定运行。因网络故障、设备原因、第三方服务中断、系统维护或不可抗力造成的暂时不可用，我们不承担超出法律规定的责任。']
        }, {
          title: '适用法律与争议解决',
          paragraphs: ['本条款适用中华人民共和国法律。因本站内容或服务产生的争议，双方应先友好协商；协商不成时，可提交公司所在地有管辖权的人民法院解决。']
        }, {
          title: '条款的更新',
          paragraphs: ['我们可能根据业务与法规变化更新本条款，更新后在本页面公布。继续使用本站即视为接受更新后的条款。']
        }, {
          title: '联系我们',
          paragraphs: ['电话：0510-85382052；邮箱：2759450915@qq.com；地址：江苏省无锡市新吴区清源路 20 号立业楼 C 栋二楼 213。']
        }]
      }
    };
    const content = computed(() => documents[props.type] || documents.privacy);
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(NavBar), _createElementVNode("main", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("header", _hoisted_4, [_createElementVNode("p", _hoisted_5, _toDisplayString(content.value.eyebrow), 1), _createElementVNode("h1", _hoisted_6, _toDisplayString(content.value.title), 1), _createElementVNode("p", _hoisted_7, _toDisplayString(content.value.summary), 1), _createElementVNode("p", {
        class: "legal-meta"
      }, " 最近更新：" + _toDisplayString(updatedAt) + " · 适用主体：无锡特文思达健康科技有限公司 ")]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.value.blocks, (block, index) => {
        return _openBlock(), _createElementBlock("section", {
          key: block.title,
          class: "legal-block"
        }, [_createElementVNode("h2", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(index + 1), 1), _createTextVNode(" " + _toDisplayString(block.title), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.paragraphs, (paragraph, i) => {
          return _openBlock(), _createElementBlock("p", {
            key: i,
            class: "legal-text"
          }, _toDisplayString(paragraph), 1);
        }), 128)), block.items ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.items, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item
          }, _toDisplayString(item), 1);
        }), 128))])) : _createCommentVNode("", true)]);
      }), 128)), _createElementVNode("div", _hoisted_11, [_cache[1] || (_cache[1] = _createElementVNode("p", {
        class: "legal-text"
      }, " 如对本页面内容有疑问，可致电 0510-85382052，或发送邮件至 2759450915@qq.com。 ", -1)), _createVNode(_component_router_link, {
        class: "legal-back",
        to: "/"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("← 返回首页")])),
        _: 1
      })])])]), _createVNode(Footer)]);
    };
  }
};